import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import FeedbackMenu from '../components/feedback/FeedbackMenu.vue';
import FeedbackList from '../components/feedback/FeedbackList.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'FeedbackView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FeedbackMenu),
    _createVNode(FeedbackList)
  ], 64))
}
}

})